// extracted by mini-css-extract-plugin
module.exports = {"info-banner":"info-banner--1gFtW","info-banner--hidden":"info-banner--hidden--294MK","info-banner__text-container":"info-banner__text-container--2Rb0_"};